import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';
import AsyncFilterSearch from '@/components/Filter/AsyncFilter/Search';

import FilterEmptyState from '../AsyncFilter/Search/FilterEmptyState';
import FilterActions from '../FilterActions';
import FilterGroup from '../FilterGroup';
import Operators from '../Operators';
import { StaticFilterProps } from '../types';
import { getMappedGroupToSelectedItems } from '../utils';
import useStaticFilter from './hooks/useStaticFilter';
import { filterHeightStyles } from './styles';

function StaticFilterDesktop(props: StaticFilterProps) {
  const {
    groups: groupsProp,
    isGroupSelectionEnabled,
    actions,
    itemRenderer,
    selectedFilters,
    showActionButtons,
    isSingleSelect,
    operators,
    selectedOperator,
  } = props;

  const {
    toggleOption,
    clearSelection,
    addMultiple,
    removeMultiple,
    onApplyFilters,
    setOperator,
    addSingle,
  } = actions;

  const { groups, searchProps } = useStaticFilter({ groups: groupsProp });

  const groupAndItemsMap = React.useMemo(
    () => getMappedGroupToSelectedItems(groups, selectedFilters),
    [groups, selectedFilters],
  );

  return (
    <Stack className="overflow-hidden" direction="col">
      {operators?.length ? (
        <Operators
          operators={operators}
          selectedOperator={selectedOperator}
          setFilterOperator={setOperator}
        />
      ) : null}
      <Box className="flex-shrink-0 px-8 pb-8 pt-12 xs:mb-0 xs:px-24 xs:pb-10">
        <AsyncFilterSearch search={searchProps} />
      </Box>
      <Box className={cn('filter-items flex-1 overflow-auto p-8', filterHeightStyles)}>
        {groups.length ? (
          groups.map((filterGroup, index) => {
            const showDivider = index < groups.length - 1;
            const selectedItemsOfGroup = groupAndItemsMap[filterGroup.id];

            return (
              <FilterGroup
                key={filterGroup.id}
                addMultiple={addMultiple}
                filterGroup={filterGroup}
                isGroupSelectionEnabled={isGroupSelectionEnabled}
                isSingleSelect={isSingleSelect}
                itemRenderer={itemRenderer}
                removeMultiple={removeMultiple}
                selectedItemsOfGroup={selectedItemsOfGroup}
                showDivider={showDivider}
                onOptionClick={isSingleSelect ? addSingle : toggleOption}
              />
            );
          })
        ) : (
          <FilterEmptyState search={searchProps} />
        )}
      </Box>
      {showActionButtons ? (
        <FilterActions onClear={clearSelection} onSave={onApplyFilters} />
      ) : null}
    </Stack>
  );
}

export default React.memo(StaticFilterDesktop);
